<template>
  <div class="flex h-16 w-16 items-center justify-center tablet:h-32 tablet:w-32">
    <img :src="logo || CompanyLogoPlaceholder" />
  </div>
</template>

<script setup lang="ts">
import CompanyLogoPlaceholder from '@/assets/images/company-logo-placeholder.png'

interface JobDetailsHeaderLogoProps {
  logo?: string | null
}

defineProps<JobDetailsHeaderLogoProps>()
</script>
